import GeneralDeclarationRequest from '../../api/requests/generalDeclarationRequest';
import AutoCompleteRequest       from 'api/requests/getCarsByQueryRequest';
import ManufacturersRequest      from 'api/requests/getManufacturersRequest';
import CarsRequest               from 'api/requests/getCarsRequest';
import CarRequest                from 'api/requests/getCarRequest';
import GetFavoriets              from 'api/requests/getFavoriets';
import NewLeadRequest            from 'api/requests/newLeadRequest';
import SendOrderSMS              from 'api/requests/sendOrderSMS';
import CheckOrderSMS             from 'api/requests/checkOrderSMS';
import CreateOrder               from 'api/requests/createOrder';
import GetContentPage            from 'api/requests/getContentPage';
import GetAppointments           from 'api/requests/getAppointments‎';
import GetOrderDetail            from 'api/requests/getOrderDetail';
import GetMetaTags               from 'api/requests/getMetaTags';
let gdRequest = new GeneralDeclarationRequest();

/* Async actions - implemented via thunk middleware */
export function getGeneralDeclaration() {
    return dispatch => {
        gdRequest.execute(dispatch);
    }
}

export function getCarsByQuery(payload) {
    let request = new AutoCompleteRequest();
    return dispatch => {
        request.execute(dispatch, payload);
    }
}

export function getManufacturers(payload) {
    let request = new ManufacturersRequest();
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}

export function getCars(payload) {
    let request = new CarsRequest();
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}

export function getCar(payload) {
    let request = new CarRequest();
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}

export function getFavoriets(payload) {
    let request = new GetFavoriets();
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}

export function sendNewLead(payload) {
    let request = new NewLeadRequest();
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}

export function sendValidationSMS(payload) {
    let request = new SendOrderSMS();
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}

export  function checkValidaationSMS(payload) {
    let request = new CheckOrderSMS();
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}

export function createOrder(payload) {
    let request = new CreateOrder();
    return dispatch =>{
        request.execute(dispatch,payload);
    }
}

export function getContentPage(payload) {
    let request = new GetContentPage();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getAppointments(payload) {
    let request = new GetAppointments();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getOrderDetail(payload) {
    let request = new GetOrderDetail();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

export function getMetaTags(payload) {
    let request = new GetMetaTags();
    return dispatch =>{
        request.execute(dispatch, payload);
    }
}

